import * as React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  muiSVG: {
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fontSize: '1.5rem',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    flexShrink: '0',
    userSelect: 'none',
  }
}));

export const Firearm = () => {
  const classes = useStyles()

  return (
    // <xml version="1.0" encoding="iso-8859-1">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="1280.000000pt" height="790.000000pt" viewBox="0 0 1280.000000 790.000000"
     preserveAspectRatio="xMidYMid meet" className={classes.muiSVG}>
      <metadata>
      Created by potrace 1.15, written by Peter Selinger 2001-2017
      </metadata>
      <g transform="translate(0.000000,790.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M10060 7870 c0 -24 -10 -37 -53 -68 -29 -22 -70 -65 -92 -96 l-38
      -56 -536 0 c-295 0 -1382 -4 -2416 -10 -1034 -5 -2794 -15 -3912 -20 l-2031
      -11 -163 82 c-150 75 -167 81 -207 75 -67 -9 -164 -60 -210 -110 -39 -42 -45
      -45 -99 -48 l-58 -3 -20 -62 c-19 -60 -21 -63 -52 -63 -27 0 -33 -4 -33 -21 0
      -36 -30 -87 -63 -107 -18 -10 -42 -39 -54 -64 -26 -52 -28 -124 -14 -464 7
      -167 11 -198 30 -237 19 -40 23 -68 28 -236 3 -105 10 -191 15 -191 4 0 8 -85
      8 -189 0 -189 0 -190 26 -220 21 -26 33 -31 68 -31 l43 0 13 -77 c7 -43 17
      -88 21 -101 l9 -22 1194 2 1195 3 7 -73 c4 -47 13 -81 24 -95 22 -27 -96 -24
      1440 -37 1226 -10 1183 -8 1292 -67 71 -38 161 -139 202 -225 59 -124 66 -153
      66 -283 1 -293 76 -515 227 -676 106 -113 218 -182 363 -227 149 -45 165 -46
      985 -32 l770 13 78 -22 c199 -55 318 -155 459 -386 47 -76 69 -132 146 -365
      212 -646 584 -1776 712 -2165 77 -231 159 -481 183 -555 l44 -135 87 0 c71 0
      89 -3 97 -17 10 -19 4 -20 -238 -39 l-153 -13 0 -63 c0 -35 3 -63 7 -63 4 0
      494 77 1088 170 2311 365 2141 337 2181 364 62 42 62 41 69 307 l7 244 -47
      135 c-96 277 -285 752 -438 1100 -192 437 -288 641 -658 1393 l-329 667 0 143
      c0 262 53 421 179 539 116 110 218 149 522 202 248 44 348 76 393 124 13 16
      19 42 23 105 3 47 3 96 -1 110 -7 29 -59 82 -100 104 -53 28 -164 61 -243 74
      -59 10 -89 20 -123 45 -65 47 -138 72 -235 83 -138 16 -224 48 -307 112 -76
      60 -143 200 -151 314 -2 28 -23 141 -46 253 l-41 202 30 75 c42 98 116 203
      187 261 74 60 195 118 303 145 96 23 134 51 151 109 16 53 8 81 -30 107 -47
      32 -107 46 -161 39 -62 -8 -172 -65 -255 -132 -38 -30 -86 -63 -105 -71 -43
      -18 -168 -28 -242 -19 l-55 7 -52 87 c-29 48 -80 126 -114 174 l-62 88 -216 0
      -215 0 -92 89 c-77 75 -92 94 -92 120 l0 31 -60 0 c-60 0 -60 0 -60 -30z
      m-9891 -442 c-5 -18 -18 -41 -30 -53 l-20 -20 15 35 c8 19 17 43 20 53 10 33
      25 18 15 -15z m-101 -120 c-23 -33 -23 -35 -23 -343 0 -296 1 -312 21 -352 12
      -24 18 -43 13 -43 -37 0 -58 187 -59 512 0 162 6 197 42 236 31 32 33 27 6
      -10z m32 -840 c0 -74 -5 -73 -14 5 -4 36 -2 57 4 57 6 0 10 -27 10 -62z m7007
      -1258 l123 0 41 -62 c49 -77 90 -161 119 -248 31 -91 39 -289 16 -380 -26
      -104 -84 -242 -157 -373 l-68 -122 -183 -6 c-352 -12 -539 -10 -602 6 -213 56
      -398 234 -467 450 -18 56 -22 92 -22 187 0 108 3 122 29 175 39 82 177 217
      269 265 158 82 406 123 674 112 57 -2 160 -4 228 -4z"/>
      </g>
    </svg>
  )
}